import { useEffect } from "react";
import { useQuery } from "react-query";
import { useDetailParam } from "../utils/detailParam";
export var useDetailEntity = function (queryKey, fetchById) {
    var _a = useDetailParam(), detailId = _a.detailId, updateDetailParam = _a.updateDetailParam;
    var _b = useQuery([queryKey, detailId], function () { return fetchById(detailId); }, { enabled: !!detailId, retry: false }), data = _b.data, isLoading = _b.isLoading, isError = _b.isError;
    useEffect(function () {
        if (detailId && isError) {
            updateDetailParam(null);
        }
    }, [detailId, isError, updateDetailParam]);
    return {
        selectedItem: data !== null && data !== void 0 ? data : null,
        detailId: detailId,
        isLoading: isLoading,
        handleRowClick: function (id) { return updateDetailParam(id); },
        handleCloseDetail: function () { return updateDetailParam(null); },
    };
};
